import React, { useContext } from 'react'
import MyImage from '@shared/components/myImage'
import styles from '@shared/components/Advertisement/AdCard/adcard.module.scss'
import ad1 from '@assets/images/Advertisement/ad1.png'
import ad2 from '@assets/images/Advertisement/ad2.png'
import ad3 from '@assets/images/Advertisement/ad3.png'
import ad4 from '@assets/images/Advertisement/ad4.png'
import ad5 from '@assets/images/Advertisement/ad5.png'
import ad6 from '@assets/images/Advertisement/ad6.png'
import adDark1 from '@assets/images/Advertisement/darkModeImages/ad1.png'
import adDark2 from '@assets/images/Advertisement/darkModeImages/ad2.png'
import adDark3 from '@assets/images/Advertisement/darkModeImages/ad3.png'
import adDark4 from '@assets/images/Advertisement/darkModeImages/ad4.png'
import adDark5 from '@assets/images/Advertisement/darkModeImages/ad5.png'
import adDark6 from '@assets/images/Advertisement/darkModeImages/ad6.png'
import GlobalEventsContext from '@shared/components/global-events/GlobalEventsContext'

const AdCard = () => {
  const { stateGlobalEvents } = useContext(GlobalEventsContext)
  const adCards = [
    { image: stateGlobalEvents?.darkModeEna === 'dark' ? adDark1 : ad1, title: 'Banners' },
    { image: stateGlobalEvents?.darkModeEna === 'dark' ? adDark2 : ad2, title: 'CTA Buttons' },
    { image: stateGlobalEvents?.darkModeEna === 'dark' ? adDark3 : ad3, title: 'Widgets' },
    { image: stateGlobalEvents?.darkModeEna === 'dark' ? adDark4 : ad4, title: 'Sponsored Articles' },
    { image: stateGlobalEvents?.darkModeEna === 'dark' ? adDark5 : ad5, title: 'Social Media Post' },
    { image: stateGlobalEvents?.darkModeEna === 'dark' ? adDark6 : ad6, title: 'Full Screen Ads' }
  ]
  return (
    <div className={styles.container}>
        {adCards.map((data, i) => {
          return (
            <div
              key={i}
              className={styles.adCard}
            >
              <div className={styles.cardContainer}>
                <MyImage
                  src={data.image}
                  alt={data.title}
                  className={styles.imageContainer}
                />
              </div>
              <div className={styles.adCardText}>
                <span className={styles.spanText}>
                  {data.title}
                </span>
              </div>
            </div>
          )
        })}
      </div>
  )
}

export default AdCard
